<template>
  <el-drawer
    :title="title"
    :visible.sync="drawer"
    profiles="rtl"
    size="75%"
    @closed="handleClosed"
    @open="handleOpen"
  >
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <el-form
              ref="form"
              :model="form"
              label-position="left"
              size="mini"
              label-width="130px"
              :rules="rules"
            >
              <el-tabs type="card">
                <el-tab-pane
                  label="General Empleados"
                  v-if="formAction !== 'view-contacts'"
                >
                  <!-- <template slot="title" class="name_clicked">
                    <h2>Generales Empleados</h2>
                    <i class="header-icon el-icon-information"></i>
                  </template> -->

                  <el-row :gutter="20" class="mt-20" type="flex column">
                    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                      <el-form-item>
                        <el-upload
                          action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
                          list-type="picture-card"
                          ref="upload"
                          :on-success="handleAvatarSuccess"
                          :file-list="fileList"
                          :disabled="disabled"
                          :limit="1"
                        >
                          <i slot="default" class="el-icon-plus"></i>
                          <div slot="file" slot-scope="{ file }">
                            <img
                              class="el-upload-list__item-thumbnail"
                              :src="file.url"
                              alt=""
                            />
                            <span class="el-upload-list__item-actions">
                              <span
                                v-if="!disabled"
                                class="el-upload-list__item-delete"
                                @click="handleRemove(file)"
                              >
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                      <!-- <el-form-item label="Nombres" prop="Name">
                        <el-input
                          v-model="form.Name"
                          :disabled="formAction === 'view'"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label="Apellidos" prop="LastName">
                        <el-input
                          v-model="form.LastName"
                          :disabled="formAction === 'view'"
                        ></el-input>
                      </el-form-item> -->

                      <el-form-item label="Nombres" prop="Name">
                        <el-col :span="11">
                          <el-input
                            v-model="form.Name"
                            :disabled="formAction === 'view'"
                            placeholder="Primer Nombre"
                          ></el-input>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                          <el-input
                            v-model="form.SecondName"
                            :disabled="formAction === 'view'"
                            placeholder="Segundo Nombre"
                          ></el-input>
                        </el-col>
                      </el-form-item>

                      <el-form-item label="Apellidos" prop="LastName">
                        <el-col :span="11">
                          <el-input
                            v-model="form.LastName"
                            :disabled="formAction === 'view'"
                            placeholder="Primer Apellido"
                          ></el-input>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                          <el-input
                            v-model="form.SecondLastName"
                            :disabled="formAction === 'view'"
                            placeholder="Segundo Apellido"
                          ></el-input>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        label="Identificación"
                        prop="DocumentNumber"
                      >
                        <el-col :span="11">
                          <el-input
                            v-model="form.DocumentNumber"
                            :disabled="formAction === 'view'"
                            placeholder="Cedúla"
                          ></el-input>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                          <el-input
                            v-model="form.License"
                            :disabled="formAction === 'view'"
                            placeholder="Licencia"
                          ></el-input>
                        </el-col>
                      </el-form-item>

                      <el-form-item label="Email" prop="Email">
                        <el-col :span="24">
                          <el-input
                            v-model="form.Email"
                            :disabled="formAction === 'view'"
                          ></el-input>
                        </el-col>
                      </el-form-item>

                      <el-form-item label="Email Personal" prop="EmailPerso">
                        <el-col :span="24">
                          <el-input
                            v-model="form.EmailPerso"
                            :disabled="formAction === 'view'"
                          ></el-input>
                        </el-col>
                      </el-form-item>

                      <!-- <el-form-item label="Telefono" prop="PhoneNumber">
                        <el-input
                          v-model="form.PhoneNumber"
                          :disabled="formAction === 'view'"
                          placeholder="Telefono"
                        ></el-input>
                      </el-form-item> -->

                      <el-form-item label="Contacto" prop="PhoneNumber">
                        <el-col :span="9">
                          <el-input
                            v-model="form.PhoneNumber"
                            :disabled="formAction === 'view'"
                            placeholder="Celular"
                          ></el-input>
                        </el-col>
                        <el-col :span="9">
                          <el-input
                            v-model="form.Fleet"
                            :disabled="formAction === 'view'"
                            placeholder="Flota"
                          ></el-input>
                        </el-col>
                        <!-- <el-col class="line" :span="2">-</el-col> -->
                        <el-col :span="6">
                          <el-input
                            v-model="form.Extension"
                            :disabled="formAction === 'view'"
                            placeholder="Ext."
                          ></el-input>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Dirección" prop="Address">
                        <el-col :span="24">
                          <el-input
                            type="textarea"
                            :rows="2"
                            v-model="form.Address"
                            :disabled="formAction === 'view'"
                          ></el-input>
                        </el-col>
                      </el-form-item>
                      <el-col :span="12">
                        <el-form-item label="Es Extranjero ? :" prop="Turn">
                          <el-row>
                            <el-switch
                              v-model="form.IsForeigner"
                              :width="45"
                              size="mini"
                              active-text="Si"
                              inactive-text="No"
                              active-color="#00fb00"
                              inactive-color="#ff0000"
                              :disabled="formAction === 'view'"
                              name="Es Contratista ? :"
                            ></el-switch>
                          </el-row>
                        </el-form-item>
                      </el-col>
                      <el-col>
                        <el-form-item label="No. Pase :">
                          <el-row>
                            <el-input
                              v-model="form.No_Pase"
                              :disabled="formAction === 'view'"
                            ></el-input>
                          </el-row>
                        </el-form-item>
                      </el-col>

                      <el-col v-if="form.Status == 'INA'">
                        <el-form-item label="Notas de Recursos Humanos">
                          <el-row>
                            <el-input
                              type="textarea"
                              :rows="2"
                              v-model="form.NoteRRHH"
                              :disabled="formAction === 'view'"
                            ></el-input>
                          </el-row>
                        </el-form-item>
                      </el-col>

                      <el-col v-if="form.Status == 'INA'">
                        <el-form-item label="Último Salario Devengado">
                          <el-row>
                            <el-input
                              v-model="form.LastSalary"
                              :disabled="formAction === 'view'"
                            ></el-input>
                          </el-row>
                        </el-form-item>
                      </el-col>
                    </el-col>

                    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                      <el-form-item label="Nacimiento" prop="DateOfBirth">
                        <el-col :span="13">
                          <el-date-picker
                            type="date"
                            placeholder="Fecha Nacimiento"
                            v-model="form.DateOfBirth"
                            :disabled="formAction === 'view'"
                            style="width: 100%"
                          ></el-date-picker>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Ingreso" prop="StartDate">
                        <el-col :span="13">
                          <el-date-picker
                            type="date"
                            placeholder="Fecha Ingreso"
                            v-model="form.StartDate"
                            :disabled="formAction === 'view'"
                            style="width: 100%"
                          ></el-date-picker>
                        </el-col>
                      </el-form-item>
                      <div v-if="form.Status == 'INA'">
                        <el-form-item label="Salida" prop="DepurateDate">
                          <el-col :span="13">
                            <el-date-picker
                              type="date"
                              placeholder="Fecha de salida"
                              v-model="form.DepurateDate"
                              :disabled="formAction === 'view'"
                              style="width: 100%"
                            ></el-date-picker>
                          </el-col>
                        </el-form-item>
                      </div>

                      <el-form-item label="Profesión" prop="Profession">
                        <el-col :span="13">
                          <el-input
                            v-model="form.Profession"
                            :disabled="formAction === 'view'"
                          ></el-input>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Tipo Sangre" prop="BloodType">
                        <el-col :span="15">
                          <el-select
                            v-model="form.BloodType"
                            placeholder="Select Tipo Sangre"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option label="O-" :value="0"></el-option>
                            <el-option label="0+" :value="1"></el-option>
                            <el-option label="A-" :value="2"></el-option>
                            <el-option label="A+" :value="3"></el-option>
                            <el-option label="B-" :value="4"></el-option>
                            <el-option label="B+" :value="5"></el-option>
                            <el-option label="AB-" :value="6"></el-option>
                            <el-option label="AB+" :value="7"></el-option>
                            <el-option
                              label="Por Confirmar"
                              :value="8"
                            ></el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Estado Civil" prop="CivilStatus">
                        <el-col :span="15">
                          <el-select
                            v-model="form.CivilStatus"
                            placeholder="Select Estado Civil"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option label="Soltero/a" :value="0"></el-option>
                            <el-option label="Casado/a" :value="1"></el-option>
                            <el-option
                              label="Divorciado/a"
                              :value="3"
                            ></el-option>
                            <el-option label="Viudo/a" :value="4"></el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Sexo" prop="Sex">
                        <el-col :span="15">
                          <el-select
                            v-model="form.Sex"
                            placeholder="Select Sexo"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option label="Masculino" :value="0"></el-option>
                            <el-option label="Femenino" :value="1"></el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Hijos" prop="QtyChildren">
                        <el-col :span="15">
                          <el-select
                            v-model="form.QtyChildren"
                            placeholder="Select Cantidad de Hijos"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option label="N/A" :value="0"></el-option>
                            <el-option label="1" :value="1"></el-option>
                            <el-option label="2" :value="2"></el-option>
                            <el-option label="3" :value="3"></el-option>
                            <el-option label="4" :value="4"></el-option>
                            <el-option label="5" :value="5"></el-option>
                            <el-option label="6" :value="6"></el-option>
                            <el-option label="7" :value="7"></el-option>
                            <el-option label="8" :value="8"></el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                      <div v-if="form.Status == 'INA'">
                        <el-form-item
                          label="Motivo de salida:"
                          prop="MotiveForDeletion"
                        >
                          <el-select
                            v-model="form.MotiveForDeletion"
                            placeholder="Motivo de salida"
                            size="mini"
                            filterable
                            v-bind="$attrs"
                            :disabled="formAction === 'view'"
                          >
                            <el-option
                              v-for="item in reasonOfExit"
                              :key="item.Value"
                              :label="item.Label"
                              :value="item.Value"
                            >
                            </el-option>
                          </el-select>
                          <!-- <el-col :span="24">
                            <el-input
                              type="textarea"
                              :rows="2"
                              v-model="form.MotiveForDeletion"
                              :disabled="formAction === 'view'"
                            ></el-input>
                          </el-col> -->
                        </el-form-item>
                      </div>
                      <el-col v-if="form.Status == 'INA'">
                        <el-form-item label="Comentario del supervisor">
                          <el-row>
                            <el-input
                              type="textarea"
                              :rows="2"
                              v-model="form.CommentSupervisor"
                              :disabled="formAction === 'view'"
                            ></el-input>
                          </el-row>
                        </el-form-item>
                      </el-col>
                    </el-col>
                  </el-row>
                </el-tab-pane>

                <el-tab-pane
                  label="Generales del puesto"
                  v-if="formAction !== 'view-contacts'"
                >
                  <div>
                    <!-- <template slot="title" class="name_clicked">
                      <h2>Generales del Pue sto</h2>
                      <i class="header-iconel-icon-information"></i>
                    </template> -->
                    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                      <el-form-item label="Gerencia" prop="DirecctionID">
                        <el-col :span="15">
                          <el-select
                            v-model="form.DirecctionID"
                            placeholder="Select Gerencia"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option
                              v-for="dir in directions"
                              :key="dir.DirecctionID"
                              :value="dir.DirecctionID"
                              :label="dir.DirecctionName"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Cargo" prop="PositionID">
                        <el-col :span="15">
                          <el-select
                            v-model="form.PositionID"
                            placeholder="Select Posicion"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option
                              v-for="pos in posicions"
                              :key="pos.ID"
                              :value="pos.ID"
                              :label="pos.Name"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Usuario" prop="UserID">
                        <el-col :span="15">
                          <el-select
                            v-model="form.UserID"
                            placeholder="Select Usuario"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option
                              v-for="user in usuarios"
                              :key="user.Id"
                              :value="user.Id"
                              :label="user.FullName"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                      <el-form-item label="Deparmento" prop="DeparmentId">
                        <el-col :span="15">
                          <el-select
                            v-model="form.DeparmentId"
                            placeholder="Select Deparmento"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option
                              v-for="dep in departamentos"
                              :key="dep.ID"
                              :value="dep.ID"
                              :label="dep.Name"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Supervisor" prop="SuperVisorID">
                        <el-col :span="15">
                          <el-select
                            v-model="form.SuperVisorID"
                            placeholder="Select SuperVisor"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option
                              v-for="pro in supervisor"
                              :key="pro.Id"
                              :value="pro.Id"
                              :label="`${pro.Name} ${pro.LastName}`"
                            >
                              <!-- {{ pro.Name + " " + pro.LastName }} -->
                            </el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Estatus" prop="Status">
                        <el-col :span="15">
                          <el-select
                            v-model="form.Status"
                            placeholder="Select Status"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option label="ACTIVO" value="ACT"></el-option>
                            <el-option label="INACTIVO" value="INA"></el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                      <el-form-item label="Cuenta Banco" prop="BankAccount">
                        <el-col :span="12">
                          <el-input
                            v-model="form.BankAccount"
                            :disabled="formAction === 'view'"
                          ></el-input>
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Turno" prop="Turn">
                        <el-col :span="15">
                          <el-select
                            v-model="form.Turn"
                            placeholder="Select Turno"
                            filterable
                            :disabled="formAction === 'view'"
                          >
                            <el-option label="TURNO 1" :value="0"></el-option>
                            <el-option label="TURNO 2" :value="1"></el-option>
                            <el-option label="TURNO 3" :value="2"></el-option>
                            <el-option label="TURNO 4" :value="3"></el-option>
                          </el-select>
                        </el-col>
                      </el-form-item>
                      <el-col :span="12">
                        <el-form-item label="Es Contratista ? :" prop="Turn">
                          <el-row>
                            <el-switch
                              v-model="form.IsContractor"
                              :width="45"
                              size="mini"
                              active-text="Si"
                              inactive-text="No"
                              active-color="#00fb00"
                              inactive-color="#ff0000"
                              :disabled="formAction === 'view'"
                              name="Es Contratista ? :"
                            ></el-switch>
                          </el-row>
                        </el-form-item>
                      </el-col>
                    </el-col>
                    <el-col :span="7">
                      <el-form-item label="Codigo Empleado">
                        <el-col :span="17">
                          <el-input
                            v-model="form.CodEmployeer"
                            :disabled="formAction === 'view'"
                            placeholder="Codigo"
                          ></el-input>
                        </el-col>
                      </el-form-item>
                    </el-col>
                    <el-col :offset="1" :span="7">
                      <el-form-item
                        label="Empresa a la que pertenece"
                        prop="pertainingCompany"
                      >
                        <el-select
                          v-model="form.pertainingCompany"
                          placeholder="Seleccione empresa"
                          filterable
                          :disabled="formAction === 'view'"
                        >
                          <el-option
                            label="Tennos Business"
                            value="TB"
                          ></el-option>
                          <el-option
                            label="Rabbey Technology"
                            value="RB"
                          ></el-option>
                          <el-option label="MagyTrack" value="MTR"></el-option>
                          <el-option
                            label="VENTAFIEL TECHNOLOGIES"
                            value="VF"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </div>
                </el-tab-pane>

                <!-- <el-tab-pane label="Parentesco">
                  <el-row :gutter="20" >
                    <el-col span="8">
                      <el-form-item label="Nombre ">
                        <el-input
                          v-model="form.ParentName"
                          :disabled="formAction === 'view'"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="8">
                      <el-form-item label="Parentesco ">
                        <el-select
                          v-model="form.ParentType"
                          clearable
                          placeholder="Tipo"
                          :disabled="formAction === 'view'"
                          class="selectParentType"
                        >
                          <el-option
                            v-for="item in optionsParentType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col span="8">
                      <el-form-item label="Telefono ">
                        <el-input
                          v-model="form.ParentPhone"
                          :disabled="formAction === 'view'"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-tab-pane> -->

                <el-tab-pane label="Contactos de emergencia">
                  <el-row
                    :gutter="20"
                    v-for="(parent, index) in parents"
                    :key="index"
                  >
                    <el-col span="8">
                      <el-form-item label="Nombre ">
                        <el-input
                          v-model="parent.nombre"
                          :disabled="
                            formAction === 'view' ||
                            formAction === 'view-contacts'
                          "
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col span="8">
                      <el-form-item label="Parentesco ">
                        <el-select
                          v-model="parent.parentesco"
                          clearable
                          placeholder="Tipo"
                          :disabled="
                            formAction === 'view' ||
                            formAction === 'view-contacts'
                          "
                          class="selectParentType"
                        >
                          <el-option
                            v-for="item in optionsParentType"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col span="8">
                      <el-form-item label="Telefono ">
                        <el-input
                          v-model="parent.telefono"
                          :disabled="
                            formAction === 'view' ||
                            formAction === 'view-contacts'
                          "
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-button
                    type="primary"
                    v-if="
                      formAction !== 'view' && formAction !== 'view-contacts'
                    "
                    @click="addParent"
                    >Agregar más</el-button
                  >
                </el-tab-pane>

                <el-tab-pane
                  label="Generales de Nomina"
                  name="NominaGenerals"
                  v-if="formAction !== 'view-contacts'"
                >
                  <!-- <template slot="title" class="name_clicked">
                    <h2>Generales de Nomina</h2>
                  </template> -->
                  <el-tabs
                    v-model="actualTab"
                    tab-position="left"
                    @tab-click="onLeftTabsClick"
                  >
                    <el-tab-pane
                      label="Generales de Salario"
                      name="SalaryGenerals"
                    >
                      <el-card shadow="hover">
                        <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                          <el-form-item label="Tipo Cuenta">
                            <div class="box">
                              <el-select
                                v-model="form.AccountType"
                                clearable
                                placeholder="Tipo"
                                @change="handleChangeTypeAccount"
                                :disabled="formAction === 'view'"
                              >
                                <el-option
                                  v-for="item in optionsAccountType"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                >
                                </el-option>
                              </el-select>
                            </div>
                          </el-form-item>
                          <el-form-item label="Salario Actual" prop="Salary">
                            <el-input
                              style="width: 195px"
                              placeholder="Insert Salary"
                              v-model="form.Salary"
                              :disabled="formAction === 'view'"
                            >
                            </el-input>
                          </el-form-item>
                          <el-form-item label="Salario Diario">
                            <el-input
                              style="width: 195px"
                              v-model="form.CalculatedSalary"
                              disabled="disabled"
                            >
                            </el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8" :xs="8" :sm="24" :md="24" :lg="8">
                          <el-form-item label="Tipo Nomina">
                            <div class="box">
                              <el-select
                                v-model="form.PayrollType"
                                clearable
                                placeholder="Tipo"
                                :disabled="formAction === 'view'"
                                @change="handleChangePayrollType"
                              >
                                <el-option
                                  v-for="item in optionsPayrollType"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                >
                                </el-option>
                              </el-select>
                            </div>
                          </el-form-item>
                          <el-form-item label="Forma Pago">
                            <div class="box">
                              <el-select
                                v-model="form.FormPayment"
                                clearable
                                placeholder="Tipo"
                                :disabled="formAction === 'view'"
                                @change="handleChangeFormPayment"
                              >
                                <el-option
                                  v-for="item in optionsFormPayment"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value"
                                >
                                </el-option>
                              </el-select>
                            </div>
                          </el-form-item>
                        </el-col>
                      </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="Cuentas Por Cobrar" name="CxC">
                      <el-card shadow="hover">
                        <CXCemployees :EmpleeInfo="form" />
                      </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="Seguro Privado" name="PrivateInsurance">
                      <el-card shadow="hover">
                        <PrivateInsurance
                          :key="1"
                          :EmpleeInfo="employee"
                          :KeyTabs="1"
                          :actualTab="actualTab"
                        />
                      </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="Percapital" name="PERCAPITAL">
                      <el-card shadow="hover">
                        <PrivateInsurance
                          :key="2"
                          :EmpleeInfo="employee"
                          :KeyTabs="2"
                          :actualTab="actualTab"
                        />
                      </el-card>
                    </el-tab-pane>
                    <el-tab-pane
                      label="Historial de Ingresos"
                      name="IncomesHistory"
                    >
                      <el-card shadow="hover">
                        <rabbey-table-3
                          :data="IcomesData"
                          :columns="IcomesColumns"
                          :actions="Icomesactions"
                          :loading="fetchingIcomesData"
                          @rtable-push-action="handledropdownCommand"
                        />
                      </el-card>
                    </el-tab-pane>
                    <el-tab-pane
                      label="Historial de Descuentos"
                      name="DiscountHistory"
                    >
                      <el-card shadow="hover">
                        <rabbey-table-3
                          :data="DiscountsData"
                          :columns="DiscountsColumns"
                          :actions="Discountsactions"
                          :loading="fetchingDiscountsData"
                          @rtable-push-action="handledropdownCommand"
                        />
                      </el-card>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>

                <el-tab-pane
                  label="Enfoques y Requisitos del Puesto"
                  v-if="formAction !== 'view-contacts'"
                >
                  <!-- <template slot="title" class="name_clicked">
                    <h2>Enfoques y Requisitos del Puesto</h2>
                    <i class="header-icon el-icon-information"></i>
                  </template> -->
                  <el-col :span="12" :xs="12" :sm="24" :md="24" :lg="12">
                    <el-form-item label="Enfoques" prop="Approaches">
                      <el-col :span="24">
                        <el-input
                          type="textarea"
                          :rows="2"
                          v-model="form.Approaches"
                          :disabled="formAction === 'view'"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2"></el-col>
                  <el-col :span="12" :xs="12" :sm="24" :md="24" :lg="12">
                    <el-form-item label="Requisitos" prop="Requirements">
                      <el-col :span="24">
                        <el-input
                          type="textarea"
                          :rows="2"
                          v-model="form.Requirements"
                          :disabled="formAction === 'view'"
                        ></el-input>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-tab-pane>

                <el-tab-pane
                  label="Activos del empleado"
                  v-if="formAction !== 'view-contacts'"
                >
                  <!-- <template slot="title" class="name_clicked">
                    <h2>Activos del empleado</h2>
                    <i class="header-icon el-icon-information"></i>
                  </template> -->

                  <div v-if="formAction == 'edit' || formAction == 'view'">
                    <rabbey-table-3
                      :paginationApi="{
                        currentPage: page,
                        pageSize: limit,
                        total: totalItems
                      }"
                      :pageSizes="pageSizes"
                      :loading="loading"
                      :paginateFromApi="true"
                      :data="items"
                      :columns="columnsDetails"
                    />

                    <el-button
                      style="margin: 15px 0 0 10px"
                      type="success"
                      plain
                      round
                      icon="el-icon-document"
                      size="mini"
                      @click="confirmDialogExportPdf"
                    >
                      Exportar a PDF
                    </el-button>

                    <el-dialog
                      title="Vista previa del PDF"
                      width="60%"
                      :visible.sync="dialogFormVisible"
                      append-to-body
                    >
                      <div id="employee-assets-template">
                        <ExportEmployeeAssetsTemplate
                          :employeeName="`${form.Name} ${form.LastName}`"
                          :data="items"
                        />
                      </div>

                      <el-button
                        style="margin: 15px 0 0 10px"
                        type="success"
                        plain
                        round
                        icon="el-icon-document"
                        size="mini"
                        @click="exportToPDF"
                      >
                        Exportar
                      </el-button>
                      <el-button
                        style="margin: 15px 0 0 10px"
                        type="info"
                        plain
                        round
                        icon="el-icon-document"
                        size="mini"
                        @click="dialogFormVisible = false"
                      >
                        Cancelar
                      </el-button>
                    </el-dialog>
                  </div>

                  <div v-if="formAction == 'create'" style="text-align: center">
                    <p>
                      En la opcion de crear no se puede ven los activos de
                      empleado
                    </p>
                  </div>
                </el-tab-pane>

                <el-tab-pane
                  label="Documentos Empleado"
                  v-if="formAction !== 'view-contacts'"
                >
                  <!-- <template slot="title" class="name_clicked">
                    <h2>Documentos Empleado</h2>
                    <i class="header-icon el-icon-information"></i>
                  </template> -->
                  <el-row>
                    <el-col :span="8" :xs="5" :sm="24" :md="24" :lg="8">
                      <EmployeesFilesUploader
                        UploadHeader="Mapas de Gestion"
                        :DocumentType="1"
                        :EmployeeId="this.currenID"
                      />
                      <!--
                      <el-form-item
                        label="Mapas de Gestion"
                        style="font-weight: bold"
                      >
                        <el-upload
                          action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
                          list-type="picture"
                          :file-list="MapList"
                          :show-file-list="true"
                          :disabled="formAction === 'view'"
                          :on-success="SuccessMaps"
                          :on-preview="handleDownload"
                          :on-remove="handleRemoveMaps"
                          :limit="5"
                          ref="upload1"
                        >

                          <i slot="default" class="el-icon-plus"></i>

                          <div slot="file" slot-scope="{ file }">
                            <img
                              class="el-upload-list__item-thumbnail"
                              src="https://www.iconfinder.com/data/icons/line-icons-set/128/1-02-512.png"
                              alt=""
                            />
                            <span class="el-upload-list__item-actions">
                              <span
                                class="el-upload-list__item-delete"
                                @click="handleDownload(file)"
                              >
                                <i class="el-icon-download"></i>
                              </span>
                              <span
                                class="el-upload-list__item-delete"
                                @click="handleRemoveMaps(file)"
                              >
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>

                        </el-upload>
                      </el-form-item>
                      -->
                    </el-col>
                    <el-col :span="8" :xs="5" :sm="24" :md="24" :lg="8">
                      <EmployeesFilesUploader
                        UploadHeader="Solicitud Empleo"
                        :DocumentType="2"
                        :EmployeeId="this.currenID"
                      />
                      <!--
                      <el-form-item
                        label="Solicitud Empleo"
                        style="font-weight: bold"
                      >
                        <el-upload
                          action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
                          list-type="picture-card"
                          :file-list="DocList"
                          :show-file-list="true"
                          :disabled="formAction === 'view'"
                          :on-success="SuccessDocument"
                          :limit="1"
                          ref="upload2"
                        >
                          <i slot="default" class="el-icon-plus"></i>
                          <div slot="file" slot-scope="{ file }">
                            <img
                              class="el-upload-list__item-thumbnail"
                              src="https://www.iconfinder.com/data/icons/line-icons-set/128/1-02-512.png"
                              alt=""
                            />
                            <span class="el-upload-list__item-actions">
                              <span
                                class="el-upload-list__item-delete"
                                @click="handleDownload(file)"
                              >
                                <i class="el-icon-download"></i>
                              </span>
                              <span
                                class="el-upload-list__item-delete"
                                @click="handleRemoveDocument(file)"
                              >
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>
                        </el-upload>
                      </el-form-item>
                      -->
                    </el-col>
                    <el-col :span="8" :xs="5" :sm="24" :md="24" :lg="8">
                      <EmployeesFilesUploader
                        UploadHeader="Contratos"
                        :DocumentType="3"
                        :EmployeeId="this.currenID"
                      />
                      <!--/*
                      <el-form-item label="Contrato" style="font-weight: bold">
                        <el-upload
                          action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
                          list-type="picture-card"
                          :file-list="ContractList"
                          :show-file-list="true"
                          :disabled="formAction === 'view'"
                          :on-success="SuccessContract"
                          :limit="1"
                          ref="upload3"
                        >
                          <i slot="default" class="el-icon-plus"></i>
                          <div slot="file" slot-scope="{ file }">
                            <img
                              class="el-upload-list__item-thumbnail"
                              src="https://www.iconfinder.com/data/icons/line-icons-set/128/1-02-512.png"
                              alt=""
                            />
                            <span class="el-upload-list__item-actions">
                              <span
                                class="el-upload-list__item-delete"
                                @click="handleDownload(file)"
                              >
                                <i class="el-icon-download"></i>
                              </span>
                              <span
                                class="el-upload-list__item-delete"
                                @click="handleRemoveContract(file)"
                              >
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>
                        </el-upload>
                      </el-form-item>
                      */-->
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8" :xs="5" :sm="24" :md="24" :lg="8">
                      <EmployeesFilesUploader
                        UploadHeader="Papel Buena Conducta"
                        :DocumentType="4"
                        :EmployeeId="this.currenID"
                      />
                      <!--
                    <el-form-item
                      label="Papel Buena Conducta"
                      style="font-weight: bold"
                    >
                      <el-upload
                        action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
                        list-type="picture-card"
                        :file-list="ConductList"
                        :show-file-list="true"
                        :disabled="formAction === 'view'"
                        :on-success="SuccessConduct"
                        :limit="1"
                        ref="upload4"
                      >
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{ file }">
                          <img
                            class="el-upload-list__item-thumbnail"
                            src="https://www.iconfinder.com/data/icons/line-icons-set/128/1-02-512.png"
                            alt=""
                          />
                          <span class="el-upload-list__item-actions">
                            <span
                              class="el-upload-list__item-delete"
                              @click="handleDownload(file)"
                            >
                              <i class="el-icon-download"></i>
                            </span>
                            <span
                              class="el-upload-list__item-delete"
                              @click="handleRemoveConduct(file)"
                            >
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>
                        </div>
                      </el-upload>
                    </el-form-item>
                    -->
                    </el-col>
                    <el-col :span="8" :xs="5" :sm="24" :md="24" :lg="8">
                      <EmployeesFilesUploader
                        UploadHeader="Curriculum"
                        :DocumentType="5"
                        :EmployeeId="this.currenID"
                      />
                      <!--
                    <el-form-item label="Curriculum" style="font-weight: bold">
                      <el-upload
                        action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
                        list-type="picture-card"
                        :file-list="CVList"
                        :show-file-list="true"
                        :disabled="formAction === 'view'"
                        :on-success="SuccessCV"
                        :limit="1"
                        ref="upload5"
                      >
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{ file }">
                          <img
                            class="el-upload-list__item-thumbnail"
                            src="https://www.iconfinder.com/data/icons/line-icons-set/128/1-02-512.png"
                            alt=""
                          />
                          <span class="el-upload-list__item-actions">
                            <span
                              class="el-upload-list__item-delete"
                              @click="handleDownload(file)"
                            >
                              <i class="el-icon-download"></i>
                            </span>
                            <span
                              class="el-upload-list__item-delete"
                              @click="handleRemoveCV(file)"
                            >
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>
                        </div>
                      </el-upload>
                    </el-form-item>
                    -->
                    </el-col>
                    <el-col :span="8" :xs="4" :sm="24" :md="24" :lg="8">
                      <EmployeesFilesUploader
                        UploadHeader="Analisis Medicos"
                        :DocumentType="6"
                        :EmployeeId="this.currenID"
                      />
                      <!--
                    <el-form-item label="Analisis Medicos" style="font-weight: bold">
                      <el-upload
                        action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
                        list-type="picture-card"
                        :file-list="MedicalAnalysisList"
                        :show-file-list="true"
                        :disabled="formAction === 'view'"
                        :on-success="SuccessMedicalAnalysis"
                        :limit="1"
                        ref="upload6"
                      >
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{ file }">
                          <img
                            class="el-upload-list__item-thumbnail"
                            src="https://www.iconfinder.com/data/icons/line-icons-set/128/1-02-512.png"
                            alt=""
                          />
                          <span class="el-upload-list__item-actions">
                            <span
                              class="el-upload-list__item-delete"
                              @click="handleDownload(file)"
                            >
                              <i class="el-icon-download"></i>
                            </span>
                            <span
                              class="el-upload-list__item-delete"
                              @click="handleRemoveMedicalAnalysis(file)"
                            >
                              <i class="el-icon-delete"></i>
                            </span>
                          </span>
                        </div>
                      </el-upload>
                    </el-form-item>
                    -->
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="8" :xs="4" :sm="24" :md="24" :lg="8">
                      <EmployeesFilesUploader
                        UploadHeader="Políticas"
                        :DocumentType="7"
                        :EmployeeId="this.currenID"
                      />
                    </el-col>
                    <el-col :span="8" :xs="4" :sm="24" :md="24" :lg="8">
                      <EmployeesFilesUploader
                        UploadHeader="Documentos varios"
                        :DocumentType="8"
                        :EmployeeId="this.currenID"
                      />
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane
                  label="Historial de salarios"
                  v-if="formAction !== 'view-contacts'"
                >
                  <el-row>
                    <rabbey-table-3
                      :data="salaryHistoricData"
                      :columns="columnsSalaryHistoric"
                    />
                  </el-row>
                </el-tab-pane>
              </el-tabs>

              <el-form-item style="margin-top: 15px">
                <el-button
                  type="primary"
                  id="btnSave"
                  @click="onSubmit(formAction)"
                  v-loading="drawerLoading"
                  v-if="formAction !== 'view'"
                  >{{ labelButton }}</el-button
                >
                <el-button @click="onCancel">{{ labelClose }}</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import { formatArrayToElSelect, formatMonto } from "@/utils";
import EmployeesFilesUploader from "@/components/Company/EmployeesFilesUploader.vue";
import ExportEmployeeAssetsTemplate from "./ExportEmployeeAssetsTemplate.vue";
import html2pdf from "html2pdf.js";
import DatetimeFormatterVue from "@/components/functionals/DatetimeFormatter.vue";
import CXCemployees from "@/views/apps/employees/profiles/CXCemployees/CXC.vue";
import ImagePersonByEmployee from "@/components/functionals/ImagePersonByEmployee.vue";
import PrivateInsurance from "@/views/apps/employees/profiles/PrivateInsurance/PrivateInsurance.vue";
import { mapMutations } from "vuex";
import {
  IncomesColumns,
  IncomesActions
} from "@/views/apps/employees/Nomina/Columns and actions/IncomesColumnsAndActions.js";
import {
  DiscountsColumns,
  DiscountsActions
} from "@/views/apps/employees/Nomina/Columns and actions/DiscountsColumnsAndActions.js";

export default {
  name: "ProfileForm",
  components: {
    EmployeesFilesUploader,
    ExportEmployeeAssetsTemplate,
    CXCemployees,
    PrivateInsurance
  },
  data() {
    return {
      page: 1,
      limit: 10,
      totalItems: 0,
      pageSizes: [10, 30, 50, 100],
      items: [],
      dialogFormVisible: false,
      value: [],
      textarea: "",
      disabled: false,
      fileList: [],
      MapList: [],
      DocList: [],
      ContractList: [],
      CVList: [],
      MedicalAnalysisList: [],
      ConductList: [],
      employee: {},
      fetchingIcomesData: false,
      fetchingDiscountsData: false,
      IcomesData: [],
      IcomesColumns: IncomesColumns,
      Icomesactions: IncomesActions,
      DiscountsData: [],
      DiscountsColumns: DiscountsColumns,
      Discountsactions: DiscountsActions,
      actualTab: "SalaryGenerals",
      form: {
        urlimagen: "/static/images/avatar-2.jpg",
        imageUrl: "",
        Name: "",
        CompanySelected: this.$store.state.user.user.CompanySelected,
        LastName: "",
        SecondLastName: "",
        SecondName: "",
        Email: "",
        EmailPerso: "",
        DateOfBirth: "",
        PhoneNumber: "",
        DocumentNumber: "",
        Approaches: "",
        Sex: "",
        IsContractor: false,
        IsForeigner: false,
        CreatedAt: "",
        MotiveForDeletion: "",
        CommentSupervisor: "",
        NoteRRHH: "",
        LastSalary: "",
        DepurateDate: "",
        PositionID: "",
        SuperVisorID: "",
        DeparmentId: "",
        DirecctionID: "",
        UserID: "",
        DocumentUrl: "",
        MapsUrl: "",
        Requirements: "",
        ContractUrl: "",
        ConductUrl: "",
        CVtUrl: "",
        MedicalAnalysisUrl: "",
        QtyChildren: "",
        Fleet: "",
        Extension: "",
        License: "",
        Profession: "",
        BloodType: "",
        CivilStatus: "",
        BankAccount: "",
        Status: "",
        Turn: "",
        No_Pase: "",
        pertainingCompany: "",
        AccountType: 0,
        Salary: 0,
        PayrollType: 0,
        CalculatedSalary: 0,
        FormPayment: 0,
        CodEmployeer: "",
        ParentName: "",
        ParentRelationship: ""
      },
      directions: [],
      posicions: [],
      departamentos: [],
      usuarios: [],
      supervisor: [],
      reasonOfExit: [
        {
          Value: "Desahucio por parte del empleador",
          Label: "Desahucio por parte del empleador"
        },
        {
          Value: "Desahucio por parte del trabajador (Renuncia)",
          Label: "Desahucio por parte del trabajador (Renuncia)"
        },
        { Value: "Despido del trabajador", Label: "Despido del trabajador" },
        { Value: "Dimisión del trabajador", Label: "Dimisión del trabajador" }
      ],
      rules: {
        Name: [{ required: true, message: "Nombre es requerido" }],
        CompanySelected: [{ required: true, message: "Empresa es requerido" }],
        LastName: [{ required: true, message: "Apellido es requerido" }],
        Email: [{ required: true, message: "Email es requerido" }],
        EmailPerso: [
          { required: true, message: "Email Personal es requerido" }
        ],
        DateOfBirth: [{ required: true, message: "Nacimiento es requerido" }],
        PhoneNumber: [{ required: true, message: "El Telefono es requerido" }],
        Fleet: [{ required: true, message: "La Flota es requerido" }],
        DocumentNumber: [{ required: true, message: "Documento es requerido" }],
        Sex: [{ required: true, message: "Sexo es requerido" }],
        imageUrl: [{ required: true, message: "Imagen es requerido" }],
        PositionID: [{ required: true, message: "La Posicion es requerido" }],
        SuperVisorID: [{ required: true, message: "Superisor es requerido" }],
        DeparmentId: [{ required: true, message: "Departamento es requerido" }],
        DirecctionID: [{ required: true, message: "Gerencia es requerida" }],
        Status: [{ required: true, message: "Estatus es requerido" }],
        CivilStatus: [{ required: true, message: "Estado Civil es requerido" }],
        StartDate: [
          { required: true, message: "Fecha de Ingreso es requerido" }
        ],
        BloodType: [{ required: true, message: "Tipo de Sangre es requerido" }],

        Turn: [{ required: true, message: "El Turno es requerido" }],
        pertainingCompany: [
          { required: true, message: "Debe seleccionar una compañia" }
        ],
        Address: [{ required: true, message: "La Direccion es requerida" }],
        Salary: [{ required: true, message: "Salario es requerido" }]
      },
      formAction: "create",
      title: null,
      loading: false,
      drawer: false,
      drawerLoading: false,
      labelButton: "Crear",
      labelClose: "Cancel",
      currenID: 0,
      salaryHistoricData: [],
      optionsAccountType: [
        {
          value: 1,
          label: "Ahorro"
        },
        {
          value: 2,
          label: "Corriente"
        }
      ],
      optionsPayrollType: [
        {
          value: 1,
          label: "Quincenal"
        },
        {
          value: 2,
          label: "Mensual"
        },
        {
          value: 3,
          label: "Semanal"
        }
      ],
      optionsFormPayment: [
        {
          value: 1,
          label: "Cheque"
        },
        {
          value: 2,
          label: "Efectivo"
        },
        {
          value: 3,
          label: "Banco"
        }
      ],
      columnsDetails: [
        {
          prop: "No",
          label: "Numero",
          width: 100,
          sortable: true
        },
        {
          prop: "ResponsibleEmployee",
          label: "Codigo Responsable",
          width: 300,
          sortable: true
        },
        {
          prop: "ResponsibleEmployeeName",
          label: "Nombre Responsable",
          width: 300,
          sortable: true
        },
        {
          prop: "Description",
          label: "Descripcion",
          width: 340,
          sortable: true
        },
        {
          prop: "FaSubClassCode",
          label: "Clase",
          width: 230,
          sortable: true
        },
        {
          prop: "LastDateModified",
          label: "Fecha de asignacion",
          width: 130,
          sortable: true,
          formatter: DatetimeFormatterVue
        },
        {
          prop: "SerialNo",
          label: "Serial",
          width: 130,
          sortable: true
        }
      ],
      columnsSalaryHistoric: [
        {
          prop: "id",
          label: "Numero",
          width: 100
        },
        {
          prop: "emp",
          label: "Empleado",
          width: 300,
          formatter: ImagePersonByEmployee
        },
        {
          prop: "oldsalary",
          label: "Salario anterior",
          width: 200
        },
        {
          prop: "newsalary",
          label: "Salario nuevo",
          width: 200
        },
        {
          prop: "dateChange",
          label: "Fecha de cambio",
          width: 230,
          formatter: DatetimeFormatterVue
        },
        {
          prop: "updater",
          label: "Actualizador",
          width: 300,
          formatter: ImagePersonByEmployee
        }
      ],
      optionsParentType: [
        {
          value: "Padre",
          label: "Padre"
        },
        {
          value: "Madre",
          label: "Madre"
        },
        {
          value: "Hermano",
          label: "Hermano"
        },
        {
          value: "Hermana",
          label: "Hermana"
        },
        {
          value: "Esposo",
          label: "Esposo"
        },
        {
          value: "Esposa",
          label: "Esposa"
        },
        {
          value: "Hijo",
          label: "Hijo"
        },
        {
          value: "Hija",
          label: "Hija"
        }
      ],
      parents: [{ id: 0, nombre: "", parentesco: "", telefono: "" }]
    };
  },
  mounted() {
    this.getDirections();
    this.getPosicions();
    this.getDeparmentos();
    this.getUserByEmployee();
    this.getSupervisor();
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    calculateDailySalary() {
      /*
      if (this.form.PayrollType == 1) {
        const valor = Number(this.form.Salary.replace(',',''));
        const valortostring = valor / 11.915
        const valorR = formatMonto(valortostring);
        return valorR;
      }
      if (this.form.PayrollType == 2) {
        */
      const valor = Number(this.form.Salary.replace(",", ""));
      const valortostring = valor / 23.83;
      const valorR = formatMonto(valortostring);
      return valorR;
      /*
      } if (this.form.PayrollType == 3) {
        const valor = Number(this.form.Salary.replace(',',''));
        const valortostring = valor / 5.95
        const valorR = formatMonto(valortostring);
        return valorR;
      }
      */
    }
  },
  watch: {
    calculateDailySalary(newVal) {
      this.form.CalculatedSalary = newVal;
    }
  },
  methods: {
    ...mapMutations({
      changeEmployee: "employees/changeEmployee",
      changeActualLefTab: "employees/changeActualLefTab"
    }),
    renderForm(row, action) {
      this.formAction = action;
      this.employee = row;
      this.changeEmployee(row);
      if (action === "create") {
        this.title = `Crear Empleado`;
        this.formAction = "create";
        this.labelButton = "Crear";
        this.labelClose = "Cancel";
        this.drawer = true;
      } else if (action === "view") {
        this.currenID = row.ID;
        this.getProfile(row.ID);
        this.getEmergencyContactsEmployeer(row.ID);
        this.disabled = true;
        this.title = `Ver - ${row.Name}`;
        this.loading = true;
        this.drawer = true;
        this.labelClose = "Cerrar";
      } else if (action === "view-contacts") {
        this.currenID = row.ID;
        this.getProfile(row.ID);
        this.getEmergencyContactsEmployeer(row.ID);
        this.disabled = true;
        this.title = `Ver - ${row.Name}`;
        this.loading = true;
        this.drawer = true;
      } else if (action === "edit") {
        this.currenID = row.ID;
        this.getProfile(row.ID);
        this.getEmergencyContactsEmployeer(row.ID);
        this.disabled = false;
        this.labelButton = "Guardar";
        this.labelClose = "Cancel";
        this.title = `Editar - ${row.Name}`;
        this.drawer = true;
      }
    },
    getEmergencyContactsEmployeer(id) {
      this.$http
        .get(`/api/Employees/GetEmergencyContactsEmployeer/${id}`)
        .then(({ data }) => {
          this.parents = data.map((parent) => {
            return {
              id: parent.Id,
              nombre: parent.Nombre,
              parentesco: parent.Parentesco,
              telefono: parent.Telefono
            };
          });
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onCancel() {
      this.fileList = [];
      this.DocList = [];
      this.MapList = [];
      this.ContractList = [];
      this.CVList = [];
      this.MedicalAnalysisList = [];
      this.ConductList = [];
      this.$refs.form.resetFields();
      this.drawerLoading = false;
      this.drawer = false;
    },
    async onSubmit(action) {
      // validar el form
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.drawerLoading = true;
          const c = {
            CompanySelected: this.company,
            ...this.form,
            Personal_Email: this.form.EmailPerso
          };

          // Peticion de creacion
          if (action === "create") {
            await this.$http
              .post("/api/Employees/Create", c)
              .then(({ data }) => {
                this.drawer = false;
                this.drawerLoading = false;

                const employeerId = Number(data.Message.substring(14));

                const parents = this.parents.map((parent) => {
                  return {
                    ...parent,
                    EmployerId: employeerId
                  };
                });

                this.$http.post(
                  `/api/Employees/InsertEmergencyContactsEmployeer`,
                  parents
                );

                // window.location.reload();
                this.$message({
                  type: "success",
                  message: "Creado"
                });
                this.$emit("profile-finally");
              })
              .catch((error) => {
                this.drawerLoading = false;
                this.$message.error("Erro!");
                console.error(error);
              })
              .finally(async () => {
                this.$refs.form.resetFields();
                let actualDate = new Date();
                await this.$http.get("/api/Payroll/GetNominaByDate", {
                  params: {
                    fecha: actualDate
                  }.then(() => {})
                });
                this.RecalculatePayroll();
              });
          } else if (action === "edit") {
            let actualDate = new Date();
            this.editProfile(this.currenID);

            this.$http
              .get("/api/Payroll/GetNominaByDate", {
                params: {
                  fecha: actualDate
                }
              })
              .then(() => {});
            this.RecalculatePayroll();
          } else {
            return;
          }
        } else {
          this.drawer = true;
          return false;
        }
      });
    },
    // eslint-disable-next-line
    handleAvatarSuccess(_response, file, _fileList) {
      const imageUrl = file.response[0].Url;
      this.form.imageUrl = imageUrl;
    },
    handleRemove() {
      this.fileList.pop();
      this.form.imageUrl = "";
    },
    handleRemoveMaps() {
      this.MapList.pop();
      this.form.MapsUrl = "";
    },
    handleRemoveDocument() {
      this.DocList.pop();
      this.form.DocumentUrl = "";
    },
    handleRemoveContract() {
      this.ContractList.pop();
      this.form.ContractUrl = "";
    },
    handleRemoveConduct() {
      this.ConductList.pop();
      this.form.ConductUrl = "";
    },
    handleRemoveCV() {
      this.CVList.pop();
      this.form.CVtUrl = "";
    },
    handleRemoveMedicalAnalysis() {
      this.MedicalAnalysisList.pop();
      this.form.MedicalAnalysisUrl = "";
    },
    SuccessMaps(_response, file) {
      const MapsUrl = file.response[0].Url;
      this.form.MapsUrl = MapsUrl;
    },
    SuccessDocument(_response, file) {
      const DocumentUrl = file.response[0].Url;
      this.form.DocumentUrl = DocumentUrl;
    },
    SuccessContract(_response, file) {
      const ContractUrl = file.response[0].Url;
      this.form.ContractUrl = ContractUrl;
    },
    SuccessConduct(_response, file) {
      const ConductUrl = file.response[0].Url;
      this.form.ConductUrl = ConductUrl;
    },
    SuccessCV(_response, file) {
      const CVtUrl = file.response[0].Url;
      this.form.CVtUrl = CVtUrl;
    },
    SuccessMedicalAnalysis(_response, file) {
      const MedicalAnalysisUrl = file.response[0].Url;
      this.form.MedicalAnalysisUrl = MedicalAnalysisUrl;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("La imagen debe estar en formato JPG!");
      }
      if (!isLt2M) {
        this.$message.error("La imagen excede los 2MB!");
      }
      return isJPG && isLt2M;
    },
    createProfile(image) {
      const c = {
        imageUrl: image,
        CompanySelected: this.company,
        ...this.form
      };
      this.$http
        .post("/api/Employees", c)
        .then(() => {
          this.drawer = false;
          this.drawerLoading = false;
          this.$message({
            type: "success",
            message: "Creado"
          });

          this.$emit("profile-finally");
        })
        .catch((error) => {
          this.drawerLoading = false;
          this.$message.error("Erro!");

          console.error(error);
        })
        .finally(() => {
          this.$refs.form.resetFields();
        });
    },
    GetFixedAssets(codEmployeer) {
      this.items = [];
      this.loading = true;
      this.$http
        .get("/api/Employees/GetFixedAssetByCodEmployees", {
          timeout: 3 * 60 * 1000,
          params: {
            Page: this.page,
            Limit: this.limit,
            codEmployeer
          }
        })
        .then((resp) => {
          const { Items, ItemCount, CurrentPage } = resp.data;

          this.items = Items;
          this.totalItems = ItemCount;
          this.page = CurrentPage;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async getProfile(
      id,
      image,
      document,
      contrat,
      conduct,
      cvurl,
      medicalanalysisUrl,
      mapurl
    ) {
      const c = {
        imageUrl: image,
        DocumentUrl: document,
        ContractUrl: contrat,
        ConductUrl: conduct,
        CVtUrl: cvurl,
        MedicalAnalysisUrl: medicalanalysisUrl,
        MapsUrl: mapurl,
        CompanySelected: this.company,
        ...this.form
      };
      await this.$http
        .get(`/api/Employees/${id}`, c)
        .then((resp) => {
          console.log("resp: ", resp.data);
          if (resp.data.imageUrl)
            this.fileList.push({ name: "food.jpeg", url: resp.data.imageUrl });
          if (resp.data.MapsUrl)
            this.MapList.push({
              name: "Mapas_Gestion " + resp.data.Name + ".pdf",
              url: resp.data.MapsUrl
            });
          if (resp.data.DocumentUrl)
            this.DocList.push({
              name: "Solicitud_Empleo " + resp.data.Name + ".pdf",
              url: resp.data.DocumentUrl
            });
          if (resp.data.ContractUrl)
            this.ContractList.push({
              name: "Contrato " + resp.data.Name + ".pdf",
              url: resp.data.ContractUrl
            });
          if (resp.data.ConductUrl)
            this.ConductList.push({
              name: "Papel_Buena_Conducta " + resp.data.Name + ".pdf",
              url: resp.data.ConductUrl
            });
          if (resp.data.CVtUrl)
            this.CVList.push({
              name: "Curriculum " + resp.data.Name + ".pdf",
              url: resp.data.CVtUrl
            });
          if (resp.data.MedicalAnalysisUrl)
            this.MedicalAnalysisList.push({
              name: "Analisis_Medico " + resp.data.Name + ".pdf",
              url: resp.data.MedicalAnalysisUrl
            });

          this.DocumentUrl;
          this.ContractUrl;
          this.ConductUrl;
          this.CVtUrl;
          this.MedicalAnalysisUrl;
          this.MapsUrl;
          this.loading = false;
          this.form = resp.data;
          this.$set(this.form, "EmailPerso", resp.data.Personal_Email || "");
          this.form.Salary = formatMonto(resp.data.Salary);
          this.form.CalculatedSalary = formatMonto(resp.data.CalculatedSalary);
          console.log("form: ", this.form);
        })
        .catch((err) => {
          this.loading = false;
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
      this.GetFixedAssets(this.form.CodEmployeer);
      this.GetHistoricDataByEmployee(this.currenID);
    },
    editProfile(id, imageUrl) {
      //Creando un nuevo objeto
      this.form.Salary = Number(this.form.Salary.replace(",", ""));
      this.form.CalculatedSalary = Number(
        this.form.CalculatedSalary.replace(",", "")
      );
      const c = {
        imageUrl: imageUrl,
        CompanySelected: this.company,
        ...this.form,
        Personal_Email: this.form.EmailPerso
      };

      this.$http
        .put(`/api/Employees/${id}`, c)
        .then(() => {
          const parents = this.parents.map((parent) => {
            return {
              ...parent,
              EmployerId: id
            };
          });

          this.$http.post(
            `/api/Employees/UpdateEmergencyContactsEmployeer/${id}`,
            parents
          );

          this.$message({
            type: "success",
            message: "Actualizado"
          });

          this.$emit("profile-finally");
        })
        .catch(() => {
          this.$message.error("Erro!");
        })
        .finally(() => {
          this.$emit("profile-finally");
          this.drawer = false;
          this.drawerLoading = false;
          this.$refs.form.resetFields();
        });
    },
    handleClosed() {
      this.fileList = [];
      this.DocList = [];
      this.MapList = [];
      this.ContractList = [];
      this.ConductList = [];
      this.CVList = [];
      this.MedicalAnalysisList = [];
      this.currenID = 0;
      this.actualTab = "SalaryGenerals";

      this.$refs.form.resetFields();
    },
    handleOpen() {
      this.actualTab = "SalaryGenerals";
      this.changeActualLefTab("SalaryGenerals");
    },
    getDirections() {
      this.$http
        .get("/api/Directions", {
          params: {
            CompanySelected: this.currentCompany
          }
        })
        .then((resp) => {
          this.directions = formatArrayToElSelect(resp.data, {
            value: "DirecctionID",
            label: "DirecctionName"
          });

          if (resp.data.length === 0) {
            this.showMessage("Direcciones");
          }
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getDeparmentos() {
      this.$http

        .get("/api/Deparments/all", {
          params: {
            companyId: this.currentCompany
          }
        })
        .then((resp) => {
          this.departamentos = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getPosicions() {
      this.$http
        .get("/api/Postition/GetPositionByCompany", {
          params: {
            companyId: this.currentCompany
          }
        })
        .then((resp) => {
          this.loading = false;
          this.posicions = resp.data;
        })
        .catch((err) => {
          this.loading = false;
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getUserByEmployee() {
      this.$http
        .get("/api/Employees/GetUser", {
          params: {
            companycode: this.currentCompany
          }
        })
        .then((resp) => {
          this.usuarios = resp.data;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    getSupervisor() {
      this.$http
        .get("/api/Employees/GetByCompany", {
          params: {
            companyId: this.currentCompany
          }
        })
        .then((resp) => {
          const employesMN = resp.data.filter((e) => e.EmployFrom === "MN");
          this.supervisor = employesMN;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    },
    handleDownload(file) {
      let link = document.createElement("a");
      link.href = file.url;
      link.download = "download";
      link.target = "_blank";
      link.click();
    },

    handleChangeTypeAccount(type) {
      this.form.AccountType = type;
    },
    handleChangePayrollType(type) {
      this.form.PayrollType = type;
    },
    handleChangeFormPayment(type) {
      this.form.FormPayment = type;
    },
    async exportToPDF() {
      try {
        const element = await document.getElementById(
          "employee-assets-template"
        );

        const options = {
          margin: 0,
          filename: "myfile.pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
          pagebreak: { mode: ["avoid-all", "css", "legacy"] }
        };

        await html2pdf()
          .set(options)
          .from(element)
          .save(
            `Activos del empledo ${this.form.Name} ${this.form.LastName}.pdf`
          );
      } catch (error) {
        console.error("Error al generar el PDF:", error);
      }
    },
    confirmDialogExportPdf() {
      this.dialogFormVisible = true;
    },
    GetHistoricDataByEmployee(id) {
      this.$http
        .get("/api/Employees/GetSalaryHistoricbyEmployee", {
          timeout: 3 * 60 * 1000,
          params: {
            id: id
          }
        })
        .then((resp) => {
          this.salaryHistoricData = resp.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async RecalculatePayroll() {
      const body = {};
      await this.$http
        .put("/api/Payroll/RecalcularNominaDesdeFuera", body)
        .then(() => {})
        .catch((err) => {
          console.error(err);
        });
    },
    RecalculateNomina(nomina) {
      this.$http
        .get("/api/Payroll/RecalcularNomina", {
          params: {
            NominaID: nomina.Id,
            Biweekly: nomina.Biweekly,
            fromDate: nomina.Desde,
            toDate: nomina.Hasta,
            NominaName: nomina.Name,
            companyID: this.currentCompany,
            User: this.currentUser.UserID,
            isNew: false
          }
        })
        .then((resp) => {
          resp;
          //this.NominaData = resp.data
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.GetNominaReport();
        });
    },
    onLeftTabsClick(actualTab) {
      this.changeActualLefTab(actualTab.name);
      switch (actualTab.name) {
        case "IncomesHistory": {
          this.GetIncomeData();
          break;
        }
        case "DiscountHistory": {
          this.GetDiscountData();
          break;
        }
      }
    },
    async GetIncomeData() {
      this.fetchingIcomesData = true;
      const QueryString = {
        params: {
          employeeId: this.employee.ID
        }
      };
      await this.$http
        .get("/api/Payroll/GetIncomesByEmployee", QueryString)
        .then((resp) => {
          this.IcomesData = resp.data;
        });
      this.fetchingIcomesData = false;
    },
    async GetDiscountData() {
      this.fetchingDiscountsData = true;
      const QueryString = {
        params: {
          employeeId: this.employee.ID
        }
      };
      await this.$http
        .get("/api/Payroll/GetDiscountsByEmployee", QueryString)
        .then((resp) => {
          this.DiscountsData = resp.data;
        });
      this.fetchingDiscountsData = false;
    },
    async handledropdownCommand(action) {
      switch (action.command) {
        case "delete_income": {
          this.DeleteIncome(action.row);
          break;
        }
        case "delete_discount": {
          this.DeleteDiscount(action.row);
          break;
        }
      }
    },
    async DeleteIncome(income) {
      const body = {
        params: {
          Id: income.Id
        }
      };

      await this.$http
        .delete("/api/payroll/DeleteIncome", body)
        .then(async () => {
          await this.GetIncomeData();
        });
    },
    async DeleteDiscount(discount) {
      const body = {
        params: {
          Id: discount.Id
        }
      };

      await this.$http
        .delete("/api/payroll/DeleteDiscounts", body)
        .then(async () => {
          await this.GetDiscountData();
        });
    },
    addParent() {
      if (this.parents.length < 5)
        this.parents.push({ id: 0, nombre: "", parentesco: "", telefono: "" });
    }
  }
};
</script>

<style scoped>
.selectParentType {
  width: 100%;
}
</style>
